import { io } from "socket.io-client";

const socket = io(
  "https://api.getcoredispatch.cloud",
  {
    transports: ["websocket"],
    autoConnect: true,

    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,

    timeout: 20000,

    forceNew: false,
    multiplex: true,
  }
);

socket.on("connect", () => {
  console.log("✅ SOCKET CONNECTED", socket.id);
});

socket.on("disconnect", () => {
  console.log("❌ SOCKET DISCONNECTED");
});

export default socket;